import RadioSet from "./RadioSet"
import Option from "./RadioOption"

export default Object.assign(RadioSet, { Option })
